import { useId, forwardRef } from "react";
import { X } from "lucide-react";

const FormField = forwardRef(function FormField(
  {
    label,
    icon,
    value,
    onChange,
    onClear,
    placeholder,
    type = "text",
    prefix,
    suffix,
    rightSlot,
    error,
    className = "",
    inputClassName = "",
    ...props
  },
  ref
) {
  const inputId = useId();
  const errId = useId();

  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 ml-1"
        >
          {label}
        </label>
      )}
      <div
        className={
          error
            ? "flex items-center gap-3 border border-red-400/70 dark:border-red-500/50 rounded-icon bg-transparent dark:bg-transparent px-3 py-2.5 focus-within:border-red-500 focus-within:ring-4 focus-within:ring-red-500/10 transition-all duration-200 ease-out"
            : "flex items-center gap-3 border border-slate-200/60 dark:border-slate-700/50 rounded-icon bg-transparent dark:bg-transparent px-3 py-2.5 focus-within:border-brand/50 focus-within:ring-4 focus-within:ring-brand/10 dark:focus-within:border-blue-500/50 dark:focus-within:ring-blue-500/10 transition-all duration-200 ease-out"
        }
      >
        {icon && (
          <div className="text-slate-400 dark:text-slate-500 shrink-0">{icon}</div>
        )}
        {prefix && (
          <span className="shrink-0 text-[15px] text-slate-400 dark:text-slate-500 select-none pointer-events-none">
            {prefix}
          </span>
        )}
        <input
          ref={ref}
          id={inputId}
          type={type}
          className={`kv-field-control bg-transparent outline-none w-full text-[16px] text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 min-w-0 text-left ${inputClassName}`}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errId : undefined}
          {...props}
        />
        {suffix && (
          <span className="shrink-0 text-[15px] text-slate-400 dark:text-slate-500 select-none pointer-events-none">
            {suffix}
          </span>
        )}
        {onClear && value && (
          <button
            type="button"
            onClick={onClear}
            className="shrink-0 text-slate-300 dark:text-slate-600 hover:text-slate-500 dark:hover:text-slate-400 transition-colors duration-150 p-0.5"
            aria-label="Borrar"
          >
            <X size={14} />
          </button>
        )}
        {rightSlot && <div className="shrink-0 flex items-center">{rightSlot}</div>}
      </div>
      {error && (
        <p id={errId} className="text-[12px] text-red-500 dark:text-red-400 ml-1">
          {error}
        </p>
      )}
    </div>
  );
});

export default FormField;
